if (!customElements.get("s-featured-blog")) {
  customElements.define(
    "s-featured-blog",
    class SectionFeaturedBlog extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.swiper = new Swiper(this, {
          slidesPerView: 1.2,
          spaceBetween: 20,
          speed: 400,
          enabled: true,
          breakpoints: {
            560: {
              slidesPerView: 2,
              spaceBetween: 20,
              enabled: true
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
              enabled: true
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
              enabled: true
            },
            1200: {
              enabled: false,
              spaceBetween: 0
            }
          }
        })
      }

      disconnectedCallback() {
      }
    }
  );
}
